import { useEffect, useState } from 'react'
import { ENV } from '@shared/config/env'
import { getProfile } from '@entities/user'
import { useAppStore } from '@/store/useAppStore'
import { LinkEmailModal } from './LinkEmailModal'

const DISMISS_KEY = 'pauline:link-email-dismissed'

/**
 * Автопоказ модалки привязки email в TG-сборке, если `profile.email == null`.
 * Показывается один раз за сессию (после закрытия). Требует что профиль уже загружен.
 */
export const LinkEmailAutoPromptTg = () => {
  const profile = useAppStore((s) => s.profile)
  const setProfile = useAppStore((s) => s.setProfile)
  const authStatus = useAppStore((s) => s.authStatus)
  const [open, setOpen] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!ENV.IS_TG) return
    if (checked) return
    if (authStatus !== 'success') return
    setChecked(true)
    if (sessionStorage.getItem(DISMISS_KEY)) return

    const run = async () => {
      let p = profile
      if (!p) {
        try { p = await getProfile(); setProfile(p) } catch { return }
      }
      if (!p.email) setOpen(true)
    }
    void run()
  }, [authStatus, profile, setProfile, checked])

  if (!open) return null
  return (
    <LinkEmailModal
      onClose={() => {
        sessionStorage.setItem(DISMISS_KEY, '1')
        setOpen(false)
      }}
    />
  )
}
